import axios from "axios";
export const misMixins = {
  methods: {
    formatoFecha(f) {
      // Convierte un texto de la forma 2017/01/10 a la forma
      return f.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3-$2-$1");
    },
    formatoFechaEn(f) {
      var fIn = f.split("-");
      var d = fIn[2] + "-" + fIn[1] + "-" + fIn[0];
      return d;
    },
    formateaRut(rut) {
      var sinPuntos = "";
      var actual = rut.replace(/^0+/, "");
      if (actual != "" && actual.length > 1) {
        sinPuntos = actual.replace(/\./g, "");
        var actualLimpio = sinPuntos.replace(/-/g, "");
        var inicio = actualLimpio.substring(0, actualLimpio.length - 1);
        var rutPuntos = "";
        var i = 0;
        var j = 1;
        for (i = inicio.length - 1; i >= 0; i--) {
          var letra = inicio.charAt(i);
          rutPuntos = letra + rutPuntos;
          if (j % 3 == 0 && j <= inicio.length - 1) {
            rutPuntos = "" + rutPuntos;
          }
          j++;
        }
        var dv = actualLimpio.substring(actualLimpio.length - 1);
        rutPuntos = rutPuntos + "-" + dv;
      }
      return rutPuntos;
    },
    validaRut(rut) {
      if (rut.toString().trim() !== "" && rut.toString().indexOf("-") > 0) {
        var caracteres = new Array();
        var serie = new Array(2, 3, 4, 5, 6, 7);
        var dig = rut.toString().substr(rut.toString().length - 1, 1);
        rut = rut.toString().substr(0, rut.toString().length - 2);

        for (var i = 0; i < rut.length; i++) {
          caracteres[i] = parseInt(rut.charAt(rut.length - (i + 1)));
        }
        var sumatoria = 0;
        var k = 0;
        var resto = 0;
        for (var j = 0; j < caracteres.length; j++) {
          if (k === 6) {
            k = 0;
          }
          sumatoria += parseInt(caracteres[j]) * parseInt(serie[k]);
          k++;
        }
        resto = sumatoria % 11;
        var dv = 11 - resto;
        if (dv === 10) {
          dv = "K";
        } else if (dv === 11) {
          dv = 0;
        }
        if (
          dv.toString().trim().toUpperCase() ===
          dig.toString().trim().toUpperCase()
        )
          return true;
        else return false;
      } else {
        return false;
      }
    },
    obtenerDv(rut) {
      if (rut.toString().trim() !== "" && rut.toString().indexOf("-") > 0) {
        var dig = rut.toString().substr(rut.toString().length - 1, 1);
        return dig;
      }
    },
    obtenerSoloRut(rut) {
      if (rut.toString().trim() !== "" && rut.toString().indexOf("-") > 0) {
        rut = rut.toString().substr(0, rut.toString().length - 2);
        return rut;
      }
    },
    async loadRegionComuna() {
      return await axios
        .get("/comunas")
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    async loadDataComuna() {
      this.genRegionComuna = await this.loadRegionComuna();
      let comun = [];
      let reg = [];
      this.genRegionComuna.forEach(function (r) {
        reg.push({ nombre: r.nombre, code: r.id, codigoReg: r.codigo });
        r.lstComunas.forEach(function (c) {
          comun.push({ nombre: c.nombre, code: c.id, codigoCom: c.codigo });
        });
      });
      this.regionesSelect = reg;
      this.comunasSelect = comun;
      return;
    },
    comunaFiltro() {
      let regionId = this.regionValue;
      let encontrarComuna = this.genRegionComuna.find(function (x) {
        return x.id == regionId;
      });
      let comun = [];
      encontrarComuna.lstComunas.forEach(function (c) {
        comun.push({ nombre: c.nombre, code: c.id, codigoCom: c.codigo });
      });
      this.comunasSelect = comun;
    },
    filenameNew(filename) {
      //cadena   separador  limite,   carpeta/archivo
      var filenameNuevo = filename.split("/");
      var obtenerUltimo = filenameNuevo.pop();
      //console.log(obtenerUltimo);
      return obtenerUltimo;
    },
    saludar: function () {
      console.log("Hola desde mixin");
    },
    despedirse: function () {
      console.log("Adios desde mixins");
    },
  },
};
